module.exports = __webpack_public_path__ + "img/img003.3d1a69c7.png";